import { Text } from '@pets-ui/Text/Text'
import { useTranslation } from 'react-i18next'
import { type OrderModel } from '../model/order-model'
import style from '../style/components/order-brands.module.scss'
import { OrderCard } from './order-card'

interface Props {
  order: OrderModel
}
export const OrderBrands = (props: Props) => {
  const childOrders = props.order.getChildOrders()
  const { t } = useTranslation()

  return (
    <section className={style.wrapper}>
      <Text variant="h5">{t('product.purchaseItems')}</Text>
      {Object.keys(childOrders).map((project) => {
        return (
          <OrderCard
            key={project}
            projectCode={project}
            childOrders={childOrders?.[project] ?? []}
          />
        )
      })}
    </section>
  )
}
